import { Injectable } from '@angular/core';
import { DataCollectorService } from '../data_collector_services/data_collector_service.service';
import moment, { Moment } from 'moment';
import RRule, { Weekday } from 'rrule';

@Injectable({
    providedIn: 'root'
})
export class PPMsService {
    get ppmUrl(): string{
        return `${this.dataCollectorService.baseurl()}/ppm`;
    }
    get ppmsApiUrls(): any{
        return {
            dataUrl: `${this.dataCollectorService.baseurl()}/ppm/filter`,
            filterUrl: `${this.dataCollectorService.baseurl()}/ppm/meta/filter`,
            jobBulkAction: `${this.dataCollectorService.baseurl()}/ppm/job/bulk`,
            contractUrl: `${this.dataCollectorService.baseurl()}/service_contract`,
            productUrl: `${this.dataCollectorService.baseurl()}/product`,
            holidayUrl: `${this.dataCollectorService.baseurl()}/company/holidays`,
            assetsUrl: `${this.dataCollectorService.baseurl()}/assets`,
            propertiesUrl: `${this.dataCollectorService.baseurl()}/property`,
        };
    }
    get ppmJobUrl(): string{
        return `${this.dataCollectorService.baseurl()}/jobs`;
    }

    constructor(private dataCollectorService: DataCollectorService) {
    }

    getPPMDetails(ppmId: string): string {
        return `${this.ppmUrl}/${ppmId}`;
    }

    deletePPM(ppmId: string): string {
        return `${this.ppmUrl}/${ppmId}`;
    }

    jobCategoryUrl(): string {
        return `${this.dataCollectorService.baseurl()}/jobs/category`;
    }

    assetUrl(assetId: string): string {
        return `${this.dataCollectorService.baseurl()}/assets/${assetId}`;
    }

    serviceContractUrl(contractId: string): string {
        return `${this.dataCollectorService.baseurl()}/service_contract/${contractId}`;
    }


    generateRecurrenceRule(recurrenceValue: string, startDate: Moment, endDate: Moment, customValue?: any): any {
        const rruleOptions: any = {
            dtstart: new Date(startDate.clone().utc().format('YYYY-MM-DDTHH:mm:ss[Z]')),
            until: new Date(endDate.clone().utc().format('YYYY-MM-DDTHH:mm:ss[Z]')),
        };
        const selectedDay = moment(startDate).clone().day() - 1;
        switch (recurrenceValue) {
            case 'DAILY':
                rruleOptions.freq = RRule.DAILY;
                break;
            case 'WEEKLY':
                rruleOptions.freq = RRule.WEEKLY;
                rruleOptions.byweekday = new Weekday(selectedDay < 0 ? 6 : selectedDay);
                break;
            case 'MONTHLY':
                rruleOptions.freq = RRule.MONTHLY;
                rruleOptions.bymonthday = moment(startDate).date();
                break;
            case 'MONTH-FIRST':
                rruleOptions.freq = RRule.MONTHLY;
                rruleOptions.bymonthday = 1;
                break;
            case 'MONTHLY-ORDINAL-WEEK':
                const targetDate = moment(startDate);
                const startDateOfMonth = moment(targetDate).startOf('month');
                const weekCount = targetDate.diff(startDateOfMonth, 'week');
                rruleOptions.byweekday = new Weekday(selectedDay < 0 ? 6 : selectedDay, weekCount + 1);
                rruleOptions.freq = RRule.MONTHLY;
                break;
            case 'YEARLY':
                rruleOptions.freq = RRule.YEARLY;
                rruleOptions.bymonth = moment(startDate).month() + 1;
                rruleOptions.bymonthday = moment(startDate).date();
                break;
            case 'CUSTOM':
                if (['WEEKS', 'MONTHS'].includes(customValue.type)) {
                    rruleOptions.freq = customValue.type === 'WEEKS' ? RRule.WEEKLY : RRule.MONTHLY;
                    const byWeekday = [];
                    customValue.days.map((week, weekIndex) => {
                        week.week.map((item, dayIndex) => {
                            if (item.value && customValue.type === 'WEEKS') {
                                byWeekday.push(new Weekday(dayIndex));
                            }
                            if (item.value && customValue.type === 'MONTHS') {
                                let weekValue = weekIndex + 1;
                                weekValue = weekValue === 5 ? -1 : weekValue;
                                byWeekday.push(new Weekday(dayIndex, weekValue));
                            }
                        });
                    });
                    rruleOptions.byweekday = byWeekday;
                }else if(customValue.type === 'YEARS'){
                    const selectedMonths = customValue.months.map((month, index) => month.value ? index + 1 : null)
                    .filter(index => index !== null);
                    const selectedOrdinals = customValue.ordinals.map((ordinal, index) => ordinal.selected ? index === 31 ? -1 : index + 1 : null)
                    .filter(index => index !== null);
                    rruleOptions.bymonth = selectedMonths;
                    rruleOptions.bymonthday = selectedOrdinals;
                }

                rruleOptions.interval = Number(customValue.count);
                break;
        }
        return rruleOptions;
    }

}
